import { render, staticRenderFns } from "./accesion-center-table.vue?vue&type=template&id=4a9e7872"
import script from "./accesion-center-table.vue?vue&type=script&lang=js"
export * from "./accesion-center-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports